export default __webpack_public_path__ + "static/media/August2019.3163115a.png";